<template>
  <div class="wheel" :class="{ 'is-disabled': disabled }">
    <div class="wheel__pointer"></div>
    <div class="wheel__plate" :style="{ transform: `rotate(${rotation}deg)` }">
      <div
        v-for="prize in normalizedPrizes"
        :key="prize.slot"
        class="wheel__item"
        :style="{ transform: itemTransform(prize.slot) }"
      >
        <div class="wheel__item-inner">
          <div class="wheel__name" :style="prizeNameStyle(prize.name)">{{ prize.name }}</div>
          <div class="wheel__icon">
            <img v-if="prize.image" :src="prize.image" alt="">
            <span v-else>{{ prizeIcon(prize.type) }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="wheel__button" aria-hidden="true"></div>
  </div>
</template>

<script>
export default {
  name: 'WorldCupQuizWheel',
  props: {
    prizes: {
      type: Array,
      default: () => []
    },
    disabled: Boolean,
    spinning: Boolean,
    rotation: {
      type: Number,
      default: 0
    }
  },
  computed: {
    normalizedPrizes () {
      const map = {}
      this.prizes.forEach(item => { map[Number(item.slot)] = item })
      return Array.from({ length: 8 }).map((_, index) => {
        const slot = index + 1
        return map[slot] || { slot, name: '待配置', type: 0, image: '' }
      })
    }
  },
  methods: {
    itemTransform (slot) {
      return `rotate(${(Number(slot) - 1) * 45}deg)`
    },
    prizeNameStyle (name) {
      const weightedLength = Array.from(String(name || '')).reduce((sum, char) => {
        return sum + (char.charCodeAt(0) <= 255 ? 0.55 : 1)
      }, 0)
      const fontSize = Math.max(8, Math.min(12, Math.floor(80 / Math.max(weightedLength, 1))))
      return { fontSize: `${fontSize}px` }
    },
    prizeIcon (type) {
      const map = {
        1: '会',
        2: '群',
        3: '券',
        4: '币'
      }
      return map[Number(type)] || '奖'
    }
  }
}
</script>

<style scoped lang="scss">
.wheel {
  position: relative;
  width: 278px;
  height: 278px;
  margin: 8px auto 0;
}

.wheel__pointer {
  display: none;
}

.wheel__plate {
  position: absolute;
  inset: 0;
  border: 0;
  border-radius: 50%;
  background: url('~@/assets/image/worldcupQuiz/wheel-bg.png') center/100% 100% no-repeat;
  box-shadow: 0 14px 30px rgba(0, 0, 0, .25);
  transition: transform 3.2s cubic-bezier(.12, .66, .12, 1);
}

.wheel__item {
  position: absolute;
  inset: 0;
  transform-origin: 50% 50%;
}

.wheel__item-inner {
  position: absolute;
  inset: 0;
  text-align: center;
}

.wheel__icon {
  position: absolute;
  left: 128px;
  top: 44px;
  width: 36px;
  height: 36px;
  margin: 0;
  transform: rotate(1.33deg);
  border-radius: 50%;
  color: #fff;
  line-height: 36px;
  font-size: 15px;
  font-weight: 800;
}

.wheel__icon img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.wheel__icon span {
  display: block;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #17804a;
}

.wheel__name {
  position: absolute;
  left: calc(50% + 20px);
  top: 15px;
  width: 84px;
  height: 17px;
  margin-left: -42px;
  transform: rotate(9deg);
  overflow: hidden;
  color: #fff;
  text-shadow: 0 1px 2px rgba(0, 0, 0, .32);
  font-size: 12px;
  font-weight: 600;
  line-height: 17px;
  white-space: nowrap;
}

.wheel__button {
  position: absolute;
  left: 50%;
  top: 50%;
  z-index: 5;
  width: 76px;
  height: 76px;
  transform: translate(-50%, -50%);
  border-radius: 50%;
  background: url('~@/assets/image/worldcupQuiz/wheel-pointer.png') center/100% 100% no-repeat;
}
</style>
